import i18n from 'i18n';

const accountModules = [
  { value: 'seo', label: 'SEO' },
  { value: 'tasks', label: i18n.t('Tasks') },
  {
    value: 'content',
    label: i18n.t('Content'),
  },
  {
    value: 'paidMedia',
    label: i18n.t('PaidMedia'),
  },
  {
    value: 'courses',
    label: i18n.t('Courses'),
  },
  {
    value: 'keywordReport',
    label: i18n.t('KeywordReport'),
  },
];

export { accountModules };
